import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { URLs } from '../../core/conf/urls';
@Injectable({
  providedIn: 'root'
})
export class LookupService {

  constructor(private httpClient: HttpClient) { }

  // countries() {
  //   return this.httpClient.get(URLs.COUNTRY_ENDPOINT) as Observable<any[]>;
  // }

  // counties() {
  //   return this.httpClient.get(URLs.COUNTY_ENDPOINT) as Observable<any[]>;
  // }

}